import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { BookingService } from 'src/app/simulator-booking/services/booking.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from 'src/app/shared/services/session.service';
import { BookingRefund } from 'src/app/simulator-booking/models/booking-refund';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { BookingStatusEnum } from 'src/app/shared/models/booking-status.enum';

@Component({
    selector: 'booking-refund-modal',
    templateUrl: './booking-refund-modal.component.html',
    styleUrl: './booking-refund-modal.component.scss',
    standalone: false
})
export class BookingRefundModalComponent extends BaseModalComponent implements OnInit {
  bookingRefund: BookingRefund;
  paymentMethod: any;
  paymentIntent: any;
  isLoading: boolean = false;
  bookingStatusEnum = BookingStatusEnum;
  bookingStatusEnumKeys = Object.keys(BookingStatusEnum).filter(key => !Number.isInteger(Number(key)));
  availableAddons: any[] = [];
  selectedAddons: any[] = [];
  
  form = new FormGroup({
    refundAmount: new FormControl('', [Validators.required, Validators.min(0)]),
    reason: new FormControl(''),
    isPartialRefund: new FormControl(false),
    status: new FormControl(BookingStatusEnum.Cancelled, [Validators.required]),
    addons: new FormControl([])
  });

  constructor(
    private bookingService: BookingService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<BookingRefundModalComponent>,
    private sessionService: SessionService
  ) {
    super();
  }

  ngOnInit() {
    this.form.get('refundAmount').setValue(this.bookingRefund?.totalPrice.toString());
    this.form.get('status').setValue(BookingStatusEnum.Cancelled);
    this.getPaymentMethodForRefund();
  }

  getPaymentMethodForRefund() {
    this.isLoading = true;
    this.bookingService.getPaymentIntent(this.bookingRefund.stripePaymentIntentId, this.sessionService.getUser().stripeAccountId).subscribe({
      next: (paymentIntent: any) => {
        this.paymentIntent = paymentIntent;
        this.paymentMethod = this.paymentIntent.payment_method;
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
        this.getAddons();
      }
    });
  }

  onPartialRefundChange(event: any) {
    if (event.checked) {
      this.form.get('refundAmount').setValue('0');
      this.form.get('status').setValue(BookingStatusEnum.Booked);
    } else {
      this.form.get('refundAmount').setValue(this.bookingRefund?.totalPrice.toString());
      this.form.get('status').setValue(BookingStatusEnum.Cancelled);
    }
  }

  submit() {
    if (this.form.valid) {
      this.isLoading = true;
      this.bookingRefund.refundAmount = Number(this.form.value.refundAmount);
      this.bookingRefund.refundReason = this.form.value.reason;
      this.bookingRefund.totalPrice = this.bookingRefund.totalPrice - Number(this.form.value.refundAmount);
      this.bookingRefund.lastEditedBy = this.sessionService.getUserId();
      this.bookingRefund.organizationId = this.sessionService.getUser().organizationId;
      this.bookingRefund['timeZone'] = this.sessionService.getUser().timeZone;

      let data = {
        stripeAccountId: this.sessionService.getUser().stripeAccountId,
        stripeChargeId: this.paymentIntent.latest_charge,
        booking: this.bookingRefund,
        isPartialRefund: this.form.value.isPartialRefund
      };

      if (!this.form.value.isPartialRefund) {
        data.booking.status = BookingStatusEnum.Cancelled;
      }

      this.bookingService.refund(data).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.dialogRef.close('refund');
          } else {
            this.dialogRef.close('error');
          }
        },
        error: (error: any) => {
          console.error(error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  getAddons() {
    this.bookingService.getAddons(this.bookingRefund.id).subscribe({
      next: (results) => {
        this.bookingRefund.addons = results;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  alert(title, body, submitText) {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      width: '35vw',
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.body = body;
    dialogRef.componentInstance.submitText = submitText;
  }
}
